import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { enableMapSet } from 'immer'
import { shallowEqual } from 'react-redux'

import { IEPRecord } from 'partner360/models/masterDealer'

import { getExtendedPartnerDataById } from './api/getExtendedPartnerDataById'
import { INITIAL_STATE, NAME } from './configs'
import {
  getExtendedPartnerDataByIdFulfilled,
  getExtendedPartnerDataByIdPending,
  getExtendedPartnerDataByIdRejected,
} from './reducers/getExtendedPartnerDataByIdReducer'

enableMapSet()

export const extendedPartnerSlice = createSlice({
  name: NAME,
  initialState: INITIAL_STATE,
  reducers: {
    addEPRecord: (state, action: PayloadAction<IEPRecord>) => {
      const value = action.payload
      const key = value.epPartnerId
      state.created.set(key, value)
    },
    updateEPRecord: (state, action: PayloadAction<IEPRecord>) => {
      const value = action.payload
      const key = value.epPartnerId

      if (state.created.has(key)) {
        state.created.set(key, value)
      } else {
        if (state.modified.has(key) && shallowEqual(state.modified.get(key), value)) {
          state.modified.delete(key)
        } else {
          state.modified.set(key, value)
        }
      }
    },
    deleteEPRecord: (state, action: PayloadAction<IEPRecord>) => {
      const value = action.payload
      const key = value.epPartnerId
      state.deleted.set(key, value)

      if (state.modified.has(key)) {
        state.modified.delete(key)
      }

      if (state.created.has(key)) {
        state.created.delete(key)
      }
    },
    saveTemporaryEPDate: (state) => {
      const data = state.base.data

      state.created.forEach((value) => {
        data.set(value.epPartnerId, value)
      })

      state.modified.forEach((value) => {
        data.set(value.epPartnerId, value)
      })

      state.deleted.forEach((value) => {
        data.delete(value.epPartnerId)
      })

      state.base.data = data
      state.created = INITIAL_STATE.created
      state.modified = INITIAL_STATE.modified
      state.deleted = INITIAL_STATE.deleted
    },
    clearTemporaryEPData: (state) => {
      state.created = INITIAL_STATE.created
      state.modified = INITIAL_STATE.modified
      state.deleted = INITIAL_STATE.deleted
    },
    clearEPData: () => {
      return INITIAL_STATE
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getExtendedPartnerDataById.pending, getExtendedPartnerDataByIdPending)
    builder.addCase(getExtendedPartnerDataById.rejected, getExtendedPartnerDataByIdRejected)
    builder.addCase(getExtendedPartnerDataById.fulfilled, getExtendedPartnerDataByIdFulfilled)
  },
})

export const {
  addEPRecord,
  updateEPRecord,
  deleteEPRecord,
  clearEPData,
  clearTemporaryEPData,
  saveTemporaryEPDate,
} = extendedPartnerSlice.actions

export const extendedPartnerDataReducer = extendedPartnerSlice.reducer

import('./listeners')
